import { render, staticRenderFns } from "./DownloadWrapper.vue?vue&type=template&id=a85cd3b0"
import script from "./DownloadWrapper.vue?vue&type=script&lang=js"
export * from "./DownloadWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports